'use client'

import { ReactNode } from 'react'

import { useUserContext } from '~/providers/user-provider'

export const useExperiment = (experimentId: string) => {
	const { userQuery } = useUserContext()

	return userQuery.isSuccess && !!userQuery.data?.experiments?.[experimentId]
}

export const HasExperiment = ({
	experimentId,
	children,
}: {
	experimentId: string
	children: ReactNode
}) => {
	const hasExperiment = useExperiment(experimentId)

	return hasExperiment ? children : null
}
